export default __webpack_public_path__ + "static/media/k_wdt_c_3.ea456fce.mp3";